import React, { useCallback, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import queryString from "query-string"
import { Link } from "react-router-dom"
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import _ from 'lodash'

import RegisterContent from './content/content'
import RegisterForm from './form'
import DisplayLogos from './logos'
import RegisterResponseMessage from './register_response_message'
import GoogleSSO from '../sso/google'
import GoogleSSOContainer from '../sso/google_sso_container'

import ApiService from "../../../helpers/apiservice"
import tapfiliateTracker from "../../../helpers/tapfiliate_tracker"
import Freshchat from '../../../helpers/freshchat/freshchat';

import * as Constants from "../../../helpers/constants"
import * as Helper from "../../../helpers/helper"
import MatomoTracker from "../../../helpers/matomoTracker"
import appEventEmitter, { AppEvents } from "../../../helpers/AppEventEmitter"
import * as AuthHelpers from './../helpers/helpers'

import "react-phone-number-input/style.css"
import "../../../static/css/auth/register.css"

let vid = null

const Register = (props) => {
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState({
    message: "",
    status: "",
  })
  const [isLoading, setIsLoading] = useState(false);
  const [localCountry, setLocalCountry] = useState("US");
  const [hideRegisterForm, setHideRegisterForm] = useState(false)
  const [emailAddress, setEmailAddress] = useState('')
  const { executeRecaptcha } = useGoogleReCaptcha()

  useEffect(
    () => {
      onComponentMount()
    },
    [onComponentMount]
  )


  const triggerOktaSignIn = (data) => {
    try {
      let options = {
        prompt: 'login',
        loginHint: emailAddress
      }

      let authClient = AuthHelpers.getOktaAuthClient({
        clientId: data.client_id,
        issuer: data.issuer,
        redirectUri: data.redirect_uri
      })

      authClient.token.getWithRedirect(options)
    } catch (err) {
      console.log('Effect Errored: ', err)
    }
  }

  if (MATOMO) {
    vid = MatomoTracker.getMatomoVisitorId()
  }

  const onComponentMount = useCallback(
    () => {
      if (!ALLOW_SIGN_UP) {
        props.history.push({
          pathname: "/login",
        })
      }
      appEventEmitter.emit(AppEvents.signup_page_loaded, {
        app_version: APP_VERSION,
      })
      checkIpLocation()

      updateRegisterFormBasedOnURLSearchParams()

      tapfiliateTracker.updateTrackingId()
    },
    [props.history, updateRegisterFormBasedOnURLSearchParams]
  )

  const updateRegisterFormBasedOnURLSearchParams = useCallback(
    () => {
      const params = queryString.parse(props.location.search)

      if (Object.keys(params).indexOf("email") > -1) {
        setEmailAddress(params.email)
      }
    },
    [props.location.search]
  )

  const checkIpLocation = () => {
    ApiService.checkIpLocation()
      .then((res) => {
        if (res.status === Constants.CO_API.Success) {
          let localCountry = res.data.country_code ? res.data.country_code : "US";
          setLocalCountry(localCountry)
        }
      })
  }

  const onEmailAddressChange = (e) => {
    const email = e.target.value.trim()
    setEmailAddress(email)
    if (!Helper.validateEmailAddress(email)) {
      errors["emailAddress"] = "Please enter valid email address";
    }
    else {
      errors["emailAddress"] = ""
    }
  }

  const showApiRateLimitErrMessage = (error) => {
    let success = {
      message: error.response.data.message,
      status: error.response.data.status,
    };
    setSuccess(success);
    setHideRegisterForm(true);
  }

  const setGSSOError = (error) => {
    setErrors((prevStates) => ({
      ...prevStates, g_sso: error.error.message
    }))
  }

  const onSSOLoginClick = (e) => {
    e.preventDefault()
    appEventEmitter.emit(AppEvents.signup_button_clicked, {
      app_version: APP_VERSION,
    })
    const params = queryString.parse(props.location.search)

    if (handleSignInValidation()) {
      if (isLoading) {
        return
      }
      setIsLoading(true)
      ApiService.getSsoConfigWithEmail(emailAddress)
        .then((res) => {
          let success = {
            message: "",
            status: "",
          }
          if (res.status === Constants.CO_API.Success) {
            if (!_.isEmpty(res.data)) {
              localStorage.setItem('user_email', emailAddress)
              triggerOktaSignIn(res.data)
              setIsLoading(false)
            }
            else {
              executeRecaptcha().then((token) => {
                if (token) {

                  let body = {
                    email: emailAddress,
                    params,
                    captchaToken: token,
                    type: "individual",
                  }

                  if (MATOMO) {
                    body["vid"] = vid
                  }

                  if (window.tapfiliateTrackingId) {
                    body.affiliate = {
                      type: "tapfiliate",
                      data: {
                        tracking_id: window.tapfiliateTrackingId,
                      }
                    }
                  }

                  ApiService.onSignUpSubmit(body)
                    .then((res) => {
                      setIsLoading(false)
                      if (res.status === Constants.CO_API.Success) {
                        onSignUpSuccess(body, res)
                      } else if (res.status === Constants.CO_API.Failed) {
                        onSignUpFailed(body, res)
                      }
                    })
                    .catch((err) => {
                      showApiRateLimitErrMessage(err)
                      appEventEmitter.emit(AppEvents.signup_failed, {
                        email: emailAddress,
                        err,
                        app_version: APP_VERSION,
                      })
                      setIsLoading(false);
                      console.log("sign up api erred", err);
                    })
                } else {
                  setIsLoading(false)
                }
              })
            }
          } else {
            success.message = "Email address / Password is invalid"
            success.status = "failed"
            if (res.message !== 'unauthorized user')
              success.message = res.message ? res.message : success.message
            setSuccess(success)
            appEventEmitter.emit(AppEvents.user_login_failed, {
              app_version: APP_VERSION,
            })
          }
        })
        .catch((err) => {
          console.log("login api erred", err)
          setIsLoading(false)
          appEventEmitter.emit(AppEvents.user_login_failed, {
            app_version: APP_VERSION,
          })
        })
    }
  }


  const handleSignInValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!emailAddress) {
      formIsValid = false;
      errors["emailAddress"] = "Please enter email address";
    }
    if (emailAddress) {
      if (!Helper.validateEmailAddress(emailAddress)) {
        formIsValid = false;
        errors["emailAddress"] = "Please enter valid email address";
      }
    }
    setErrors(errors)
    return formIsValid
  }

  const onSignUpSuccess = (body, response) => {
    setSuccess({
      message: "You have successfully registered. Please check your email for the completion of the sign-up process.",
      status: 'success'
    })
    setHideRegisterForm(true)

    appEventEmitter.emit(AppEvents.signup_success, {
      ...response.data,
      body,
      app_version: APP_VERSION,
    })
  }

  const onSignUpFailed = (body, response) => {
    setSuccess({
      message: response.message,
      status: 'failed'
    })
    setHideRegisterForm(true)

    appEventEmitter.emit(AppEvents.signup_failed, {
      email: body.email,
      err: response.message,
      app_version: APP_VERSION,
    })
  }

  const showRegisterForm = () => {
    setSuccess({
      message: "",
      status: "",
    })
    setHideRegisterForm(false)
  }

  return (
    <div className='register-page-container'>
      <div className='register-inner-container'>

        <RegisterContent />
        <div className='register-form-container'>
          <div className='register-form-header'>
            <img src={IMAGES_LOGO_BLACK} alt='logo' />
            <h3>Create Free-Forever Account</h3>
            <p>To grow your business!</p>
          </div>

          <div className='register-form-content'>
            {hideRegisterForm
              ? <RegisterResponseMessage
                registerResponse={success}
                showRegisterForm={showRegisterForm}
              />
              : <React.Fragment>
                <RegisterForm
                  isLoading={isLoading}
                  emailAddress={emailAddress}
                  localCountry={localCountry}
                  onSignUpClick={onSSOLoginClick}
                  errors={errors}
                  onEmailAddressChange={onEmailAddressChange}
                />
                <div className="register-sso">
                  <GoogleSSOContainer errors={errors} />
                </div>
                <p className="register-login-link">Already a member ? &nbsp;
                  <Link to={{ pathname: "/login", search: props.location.search }}>Login</Link>
                </p>
              </React.Fragment>}
            <p className="register_policy">
              By signing up, you agree to our&nbsp;<br />
              <a
                href={Constants.CLEAROUT_WEBSITE.TERMS_AND_CONDITIONS}
                rel="noopener noreferrer"
                target="_blank"
              >
                Terms & Conditions
              </a>
              &nbsp;and&nbsp;
              <a
                href={Constants.CLEAROUT_WEBSITE.PRIVACY_POLICY}
                rel="noopener noreferrer"
                target="_blank"
              >
                Privacy Policy
              </a>
            </p>
          </div>
        </div>

        <div className='register-footer-container'>
          <h5>Trusted by Businesses of all Sizes Worldwide</h5>
          <DisplayLogos />
        </div>

      </div>

      <Freshchat {...props} />

      {ALLOW_SIGN_UP && ALLOW_SSO_SIGN_UP
        ? <GoogleSSO
          key={hideRegisterForm} // key is set to refresh google container when form hide / show
          setGSSOError={setGSSOError}
          btnText="signup_with"
          context="signup"
          btnWidth={280}
          vid={vid}
          {...props}
        />
        : null}
    </div>
  )
}
const mapDispatchToProps = (dispatch) => {
  return { dispatch }
}

export default connect(null, mapDispatchToProps)(Register)